export enum BillType {
  Shipping = "shipping",
  ReturnShipping = "return_shipping",
  Software = "software",
}
